import * as React from 'react'
function SvgLogout(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M27 4v4H9v24h18v4H7a2 2 0 01-2-2V6a2 2 0 012-2h20zm-2 7.172L33.828 20 25 28.828 22.172 26l4-4H13v-4h13.172l-4-4L25 11.172z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgLogout
